import axiosInstance from "./AxiosInstance";

class CustomerService {
  static async getCustomers(page = 1, limit = 10, search = "", archived = false) {
    try {
      const params = {
        page,
        limit,
        search,
      };
      
      if (archived) {
        params.archived = true;
      }
      
      const response = await axiosInstance.get("/v1/customers", {
        params,
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async getCustomerById(id) {
    try {
      const response = await axiosInstance.get(`/v1/customers/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async createCustomer(customerData) {
    try {
      const response = await axiosInstance.post("/v1/customers", customerData);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async updateCustomer(id, customerData) {
    try {
      const response = await axiosInstance.put(
        `/v1/customers/${id}`,
        customerData
      );
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async deleteCustomer(id) {
    try {
      const response = await axiosInstance.delete(`/v1/customers/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async archiveCustomer(customerId, isArchived = true) {
    try {
      const response = await axiosInstance.patch(`/v1/customers/${customerId}/archive`, {
        isArchived
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default CustomerService;
